import PlayPositions from "@Enums/PlayPositions";
import PlayPositionsShortnameMap from "@Enums/PlayPositionsShortnameMap";
import { Coordinates } from "./types";

export function getPlayPositionString(val: PlayPositions[] | string) {
  return typeof val === "string"
    ? PlayPositionsShortnameMap[val as PlayPositions]
    : val.map((p: PlayPositions) => PlayPositionsShortnameMap[p]).join(", ");
}

export function getCoordinatesForTeam(formation: string, prefix = "1"): Coordinates {
  const pitchWidth = 65;
  const pitchHeight = 99.3;
  const isBlueTeam = prefix === "1";
  const formationArray = formation.split("-").map(Number);

  const goalKeeperY = pitchHeight / 2 - 2;
  const coordinates: Coordinates = { [`${prefix}_1_Goalkeeper`]: { x: 0, y: isBlueTeam ? goalKeeperY : 0 - goalKeeperY } }; // Goalkeeper

  let yPosition = pitchHeight / 2 - 20; // Start position for defenders

  formationArray.forEach((playersInLine, index) => {
    const spacing = pitchWidth / (playersInLine + 1);
    for (let i = 1; i <= playersInLine; i++) {
      const playerX = i * spacing - pitchWidth / 2;
      coordinates[`${prefix}${FormationMap[formation][index][i - 1]}`] = {
        x: isBlueTeam ? playerX : 0 - playerX,
        y: isBlueTeam ? yPosition : 0 - yPosition,
      };
    }
    yPosition -= 20; // Move to next line closer to the center
  });

  return coordinates;
}

export const Formations = {
  433: "4-3-3",
  442: "4-4-2",
  4231: "4-2-3-1",
  343: "3-4-3",
  352: "3-5-2",
};

export const FormationMap: {
  [formation: string]: {
    [row: number]: string[];
  };
} = {
  [Formations[442]]: {
    0: ["_2_Right_Defender", "_4_Right_Central_Defender", "_5_Left_Central_Defender", "_3_Left_Defender"],
    1: ["_7_Right_Forward", "_6_Defensive_Midfilder", "_8_Central_Midfielder", "_11_Left_Forward"],
    2: ["_10_Attacking_Midfielder", "_9_Striker"],
  },
  [Formations[433]]: {
    0: ["_2_Right_Defender", "_4_Right_Central_Defender", "_5_Left_Central_Defender", "_3_Left_Defender"],
    1: ["_7_Right_Forward", "_6_Defensive_Midfilder", "_11_Left_Forward"],
    2: ["_10_Attacking_Midfielder", "_8_Central_Midfielder", "_9_Striker"],
  },
  [Formations[343]]: {
    0: ["_2_Right_Defender", "_4_Right_Central_Defender", "_3_Left_Defender"],
    1: ["_7_Right_Forward", "_5_Left_Central_Defender", "_6_Defensive_Midfilder", "_11_Left_Forward"],
    2: ["_10_Attacking_Midfielder", "_8_Central_Midfielder", "_9_Striker"],
  },
  [Formations[352]]: {
    0: ["_2_Right_Defender", "_4_Right_Central_Defender", "_3_Left_Defender"],
    1: ["_7_Right_Forward", "_5_Left_Central_Defender", "_6_Defensive_Midfilder", "_8_Central_Midfielder", "_11_Left_Forward"],
    2: ["_10_Attacking_Midfielder", "_9_Striker"],
  },
  [Formations[4231]]: {
    0: ["_2_Right_Defender", "_4_Right_Central_Defender", "_5_Left_Central_Defender", "_3_Left_Defender"],
    1: ["_6_Defensive_Midfilder", "_8_Central_Midfielder"],
    2: ["_7_Right_Forward", "_10_Attacking_Midfielder", "_11_Left_Forward"],
    3: ["_9_Striker"],
  },
};
